var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnifiedPlatform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.75 2H5.75C3.67893 2 2 3.67893 2 5.75V24.5C2 26.5711 3.67893 28.25 5.75 28.25H65.75C67.8211 28.25 69.5 26.5711 69.5 24.5V5.75C69.5 3.67893 67.8211 2 65.75 2Z",
    stroke: "#339999",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 43.25H5.75C3.67893 43.25 2 44.9289 2 47V65.75C2 67.8211 3.67893 69.5 5.75 69.5H24.5C26.5711 69.5 28.25 67.8211 28.25 65.75V47C28.25 44.9289 26.5711 43.25 24.5 43.25Z",
    stroke: "#339999",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.75 43.25H47C44.9289 43.25 43.25 44.9289 43.25 47V65.75C43.25 67.8211 44.9289 69.5 47 69.5H65.75C67.8211 69.5 69.5 67.8211 69.5 65.75V47C69.5 44.9289 67.8211 43.25 65.75 43.25Z",
    stroke: "#339999",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnifiedPlatform);
export default __webpack_public_path__ + "static/media/UnifiedPlatform.5851a8602bbba04b1e2d047058625d62.svg";
export { ForwardRef as ReactComponent };